/*
# -----------------------------------------------------------------------------
# Component: index.js
# Author: antonio.ramirez@pst.sg
# Created Date: 02/April/2019
# Comments: Responsible for the state management of Manage Accounts
# -----------------------------------------------------------------------------
*/
import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters/getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  accountData: {},
  accountsListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  glDetail: {
    journal: '',
    itemNo: '',
    glAcctNo: '',
    createdBy: '',
    modifiedBy: ''
  },
  acctMaster: {
    branch: '',
    acctNo: '',
    tranType: '',
    docNo: '',
    fund: '',
    suffix: '',
    rbcTran: '',
    netAmount: '',
    osBalance: '',
    transfer: '',
    actionName: ''
  },
  acctMchObj: {
    UUID: null,
    baseFromMatch: false,
    selectFromMatch: false,
    matchFileName: '',
    baseRecKey: '',
    isCancel: false,
    isUpload: false
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
